import { Select } from '@components/shared/Select'

import type { CompetenceDateSelectProps } from './types'
import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'
import { useUser } from '@hooks/useUser'

export const CompetenceDateSelect = ({
  competenceDateValue,
  setCompetenceDateValue,
  handleSetPeriodValue,
  disabled
}: CompetenceDateSelectProps) => {
  const { competenceDateData, isCompetenceDateLoading } = useUser()

  return (
    <Select
      hasController={false}
      name="dateCompetence"
      label="Data Competência"
      placeholder="Selecione a data"
      value={competenceDateValue}
      options={
        competenceDateData?.length
          ? competenceDateData?.map((item) => ({
              label: formattedDatePtBr(item.startDate) || '',
              value: item.startDate
            }))
          : []
      }
      onChange={({ target }) => {
        setCompetenceDateValue(target.value as string)
        handleSetPeriodValue({ competenceDate: target.value as string })
      }}
      disabled={disabled}
      loading={isCompetenceDateLoading}
    />
  )
}
